module.exports = __webpack_public_path__ + "img/loginImg.2c1da74c.jpg";